import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { capturePublicApi } from '../api/captureApi';
import styles from './ReviewCapturePage.module.css';

/**
 * The link in Betty's last text (/g/:shortCode): the patient already has their review in the text
 * thread to copy, so this goes straight to the practice's Google review box. The tap is recorded
 * on the way (backend openGoogleFromText); if that fails, the review page is the fallback.
 */
export function GoogleHandoffPage() {
  const { shortCode } = useParams<{ shortCode: string }>();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!shortCode) return;
    capturePublicApi
      .openGoogle(shortCode)
      .then((link) => {
        if (link?.url) window.location.replace(link.url);
        else setError(true);
      })
      .catch(() => setError(true));
  }, [shortCode]);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.center}>
          {error ? (
            <p className={styles.errorMsg}>
              We couldn’t open Google just now.{' '}
              {shortCode && (
                <Link to={`/r/${shortCode}?via=sms`}>Open your review page instead</Link>
              )}
              .
            </p>
          ) : (
            <div className={styles.spinner} aria-label="Opening Google…" />
          )}
        </div>
      </div>
    </div>
  );
}
